export var ActionTypes = {
  SHOW: 'SHOW',
  HIDE: 'HIDE'
};
export var toggle = function toggle(key, show) {
  return {
    type: show ? ActionTypes.SHOW : ActionTypes.HIDE,
    key: key
  };
};